import { Activity, AlertTriangle, CheckCircle, User } from 'lucide-react';

import { MetricCard } from './MetricCard';

import { useGetMetricsTotalizers } from '@/hooks/useGetMetricsTotalizers';

export function MetricsTotalizers() {
  const { metrics, isLoading } = useGetMetricsTotalizers();

  return (
    <div className="grid grid-cols-4 gap-4">
      <MetricCard
        title="Total Customers"
        value={
          isLoading ? (
            <span className="animate-pulse">...</span>
          ) : (
            metrics?.totalCustomers.total
          )
        }
        subtitle={`+${metrics?.totalCustomers.thisMonth} this month`}
        icon={<User className="h-6 w-6 text-blue-600" />}
      />

      <MetricCard
        title="Completion Rate"
        value={
          isLoading ? (
            <span className="animate-pulse">...</span>
          ) : (
            `${metrics?.completionRate}%`
          )
        }
        icon={<Activity className="h-6 w-6 text-blue-600" />}
      />

      <MetricCard
        title="Most Critical Step"
        value={
          isLoading ? (
            <span className="animate-pulse">...</span>
          ) : (
            <span
              className="max-w-[200px] cursor-default truncate"
              title={metrics?.mostCriticalStep.name}
            >
              {metrics?.mostCriticalStep.name}
            </span>
          )
        }
        subtitle={`${metrics?.mostCriticalStep.rate}% completion`}
        icon={<AlertTriangle className="h-6 w-6 text-blue-600" />}
      />

      <MetricCard
        title="Completed Customers"
        value={
          isLoading ? (
            <span className="animate-pulse">...</span>
          ) : (
            metrics?.completedCustomers
          )
        }
        icon={<CheckCircle className="h-6 w-6 text-blue-600" />}
      />
    </div>
  );
}
